﻿import React from 'react';

export const TwoColumnWrapper = (props) => {
  let wrappingClass = 'single-step__section-wrapper';

  if (props.modifier)
    wrappingClass += ' ' + wrappingClass + '--' + props.modifier;

  return (
    <div className={wrappingClass}>
      {props.children}
    </div>
  )
}

export const ThreeColumnWrapper = (props) => {
  const wrappingClass = 'single-step__section-wrapper-three';

  return (
    <div className={wrappingClass}>
      {props.children}
    </div>
  )
}
